import store from "@/store/index.js";
import fetchIntercept from "fetch-intercept";

export default class AuthenticationService {
  constructor() {
    this.authIntercept = fetchIntercept.register({
      request: (url, config) => {
        config.method = "POST";
        config.headers = new Headers({
          "Content-type": "application/json",
        });
        return [url, config];
      },

      requestError: (error) => {
        // Called when an error occured during another 'request' interceptor call
        return Promise.reject(error);
      },

      response: async (response) => {
        // Modify the reponse object
        if (!response.ok) {
          const message = response.status;
          throw new Error(message);
        }
        const data = await response.json();
        store.dispatch("auth/updateToken", data.authToken);
        return response;
      },

      responseError: (error) => {
        // Handle an fetch error
        return Promise.reject(error);
      },
    });
  }

  async authenticate(deviceId, deviceType, username, password) {
    const response = await fetch(process.env.VUE_APP_AUTH_ENDPOINT, {
      body: JSON.stringify({
        deviceId: deviceId,
        deviceType: deviceType,
        username: username,
        password: password,
      }),
    });
    return response;
  }

  unregister() {
    this.authIntercept();
  }
}
